import HttpApi, { HttpApiRequestOptions, HttpApiResult } from './HttpApi';
import KeyValueListDTO from '../models/generic/KeyValueListDTO';

export class GameApiController {
    // post: Game/GetGamesForAcademicStandard
    public RouteGetGamesForAcademicStandard = () => `Game/GetGamesForAcademicStandard`;
    public getGamesForAcademicStandard(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueListDTO>> {
        let url = this.RouteGetGamesForAcademicStandard();
        return HttpApi.RestRequest<any, KeyValueListDTO>(null, 'post', url, requestOptions);
    }
}
var service = new GameApiController();
export default service;



// WEBPACK FOOTER //
// ./src/api/GameApiController.ts